import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-8789f2f2"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "sqg-tableItem" }
const _hoisted_2 = { class: "sqg-tableItem__checkbox" }
const _hoisted_3 = {
  key: 1,
  class: "sqg-tableItem__logo"
}
const _hoisted_4 = { class: "sqg-tableItem__fields" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "sqg-tableItem__mark" }, null, -1))
const _hoisted_6 = ["onClick"]
const _hoisted_7 = {
  key: 1,
  class: "sqg-tableItem__field"
}
const _hoisted_8 = { class: "sqg-tableItem__actions" }
const _hoisted_9 = {
  key: 0,
  class: "sqg-tableItem__action"
}
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("i", { class: "disabled" }, null, -1))
const _hoisted_11 = [
  _hoisted_10
]
const _hoisted_12 = {
  key: 1,
  class: "sqg-tableItem__action"
}
const _hoisted_13 = ["onClick"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Checkbox = _resolveComponent("Checkbox")!
  const _component_Popper = _resolveComponent("Popper")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(), _createBlock(_component_Checkbox, {
        id: _ctx.item.id,
        checked: _ctx.isCheck,
        key: _ctx.item.id,
        onOnChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('check', { id: _ctx.item.id, actions: _ctx.item.actions })))
      }, null, 8, ["id", "checked"]))
    ]),
    (_ctx.item.bubble)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "sqg-tableItem__bubble",
          style: _normalizeStyle(`background-color: ${_ctx.randomColor(_ctx.item.id)}`)
        }, _toDisplayString(_ctx.item.bubble), 5))
      : _createCommentVNode("", true),
    (_ctx.item.logo)
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          _createElementVNode("i", {
            class: _normalizeClass(_ctx.item.logo)
          }, null, 2)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_4, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.fields, (field, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: 'field-'+index
        }, [
          _hoisted_5,
          (field.type === 'icone')
            ? (_openBlock(), _createElementBlock("div", {
                key: 0,
                class: "sqg-tableItem__field -number clickable",
                onClick: ($event: any) => (_ctx.$emit('redirect', field.redirect))
              }, [
                _createVNode(_component_Popper, {
                  arrow: true,
                  hover: true,
                  content: field.popper
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", null, [
                      _createElementVNode("i", {
                        class: _normalizeClass(field.title)
                      }, null, 2),
                      _createTextVNode(_toDisplayString(field.value), 1)
                    ])
                  ]),
                  _: 2
                }, 1032, ["content"])
              ], 8, _hoisted_6))
            : (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createElementVNode("p", null, _toDisplayString(field.title) + " :", 1),
                _createElementVNode("div", null, _toDisplayString(field.value), 1)
              ]))
        ], 64))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.actions, (action, index) => {
        return (_openBlock(), _createElementBlock(_Fragment, {
          key: 'action-'+index
        }, [
          (action.action === 'empty')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _hoisted_11))
            : (_openBlock(), _createElementBlock("div", _hoisted_12, [
                _createVNode(_component_Popper, {
                  arrow: true,
                  hover: true,
                  content: action.text
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("i", {
                      class: _normalizeClass(['clickable', action.icon]),
                      onClick: ($event: any) => (_ctx.$emit(`${action.action}`))
                    }, null, 10, _hoisted_13)
                  ]),
                  _: 2
                }, 1032, ["content"])
              ]))
        ], 64))
      }), 128))
    ])
  ]))
}